import { useTracking } from 'react-tracking';

import { Text, Heading, useMount, Grid, Button } from '@simplywallst/ui-core';

import { PortfolioIllustration } from '../../../../components/PortfolioIllustration';
import { useManualPortfolioContext } from '../../../../components/PortfolioManual';
import { PortfolioPageHeader } from '../../../../components/PortfolioPageHeader';

import type { Portfolio } from '@/hooks/portfolio/usePortfolio';

import PortfolioLinkStatus from '../../../../components/PortfolioLinkStatus';
import { PortfolioSettings } from '../PortfolioSettings';

import { Section, TextWrapper } from './styled';

type Props = {
  portfolio: Portfolio;
};

export const EmptyState = ({ portfolio }: Props) => {
  const { Track, trackEvent } = useTracking({
    type: 'track',
    modifier: 'emptyState',
  });

  const { updatePortfolio } = useManualPortfolioContext();

  useMount(() => {
    trackEvent({ action: 'landed' });
  });

  return (
    <Track>
      <PortfolioPageHeader portfolio={portfolio}>
        <PortfolioSettings portfolio={portfolio} />
      </PortfolioPageHeader>
      <PortfolioLinkStatus portfolio={portfolio} />
      <Section
        as="section"
        templateRows="auto auto"
        placeItems="center"
        gap="16px"
      >
        <PortfolioIllustration />
        <TextWrapper>
          <Heading
            as="h3"
            typography="smallStrong"
            textAlign="center"
            data-cy-id="empty-state"
          >
            No companies in your portfolio yet!
          </Heading>
          <Text typography="xSmall" textAlign="center" color="mediumGray">
            Add companies to track performance, important changes and analyze
            your portfolio quality and diversification
          </Text>
        </TextWrapper>
        {portfolio.type === 'manual' ? (
          <Grid justifyContent="center">
            <Button
              styleType="louderLarge"
              onClick={() => updatePortfolio({ portfolioId: portfolio.id })}
            >
              Add stocks
            </Button>
          </Grid>
        ) : null}
      </Section>
    </Track>
  );
};
